import { CLUSTER_KINDS } from '../cloud/cluster-state.js';
import { INVESTIGATION_PROMQL } from '../cloud/prometheus.js';
import { MAX_METRIC_HOURS, METRIC_STATISTICS, METRIC_TARGETS, METRIC_TARGET_KINDS, } from '../cloud/resource-metric.js';
/** The sections `describe_resources` answers, each from a read the checks make. */
export const DESCRIBE_SECTIONS = [
    'stacks',
    'cluster',
    'nodes',
    'network',
    'cluster_support',
    'cluster_access',
    'addons',
    'databases',
    'search',
];
/** At most this many instance types are priced in one read. */
export const MAX_PRICED_TYPES = 10;
export const INVESTIGATION_TOOLS = [
    {
        name: 'latest_checks',
        description: 'The newest completed run of the standard checks on this instance: each check, its outcome, its finding and the values it judged. Start here. Pass checkId for one check alone.',
        input_schema: {
            type: 'object',
            properties: {
                checkId: { type: 'string', description: 'One check, by its id.' },
            },
            additionalProperties: false,
        },
        access: 'read',
    },
    {
        name: 'describe_resources',
        description: "One section of this instance's own cloud resources, found by its tag: the customer stacks, the cluster, the nodes with their pools and week of CPU, the subnets and pod networking, the cluster's support window, who the cluster admits, its add-ons, the database, or the search domain.",
        input_schema: {
            type: 'object',
            properties: {
                section: { type: 'string', enum: DESCRIBE_SECTIONS },
            },
            required: ['section'],
            additionalProperties: false,
        },
        access: 'read',
    },
    {
        name: 'resource_metric',
        description: `One CloudWatch metric of one of this instance's own resources over the last 1 to ${String(MAX_METRIC_HOURS)} hours, at most a couple of hundred points. The id must be one describe_resources returned: a node's instance id, a database's identifier, or the search domain's name.`,
        input_schema: {
            type: 'object',
            properties: {
                target: { type: 'string', enum: METRIC_TARGET_KINDS },
                id: { type: 'string' },
                metric: {
                    type: 'string',
                    description: `For node: ${METRIC_TARGETS.node.join(', ')}. For database: ${METRIC_TARGETS.database.join(', ')}. For search-domain: ${METRIC_TARGETS['search-domain'].join(', ')}.`,
                },
                statistic: { type: 'string', enum: METRIC_STATISTICS },
                hours: { type: 'integer', minimum: 1, maximum: MAX_METRIC_HOURS },
            },
            required: ['target', 'id', 'metric', 'statistic', 'hours'],
            additionalProperties: false,
        },
        access: 'read',
    },
    {
        name: 'kubernetes',
        description: "One kind of object inside this instance's cluster, as the diagnostics role may read it and projected: no secrets, config maps, environment values or logs. Optionally narrowed to a namespace or a name. Needs the customer to have opened the cluster to Qrvey's diagnostics.",
        input_schema: {
            type: 'object',
            properties: {
                kind: { type: 'string', enum: CLUSTER_KINDS.map((k) => k.id) },
                namespace: { type: 'string' },
                name: { type: 'string' },
            },
            required: ['kind'],
            additionalProperties: false,
        },
        access: 'read',
    },
    {
        name: 'promql',
        description: `One instant PromQL query against this instance's own Prometheus, at the present moment. No range or offset may reach past ${INVESTIGATION_PROMQL.maxWindow}, @ is not accepted, and at most ${String(INVESTIGATION_PROMQL.maxResults)} series come back, largest first.`,
        input_schema: {
            type: 'object',
            properties: {
                query: { type: 'string', maxLength: INVESTIGATION_PROMQL.maxQueryChars },
            },
            required: ['query'],
            additionalProperties: false,
        },
        access: 'read',
    },
    {
        name: 'prices',
        description: `On-demand and one-year commitment list prices for up to ${String(MAX_PRICED_TYPES)} instance types in this instance's region, from the public price list.`,
        input_schema: {
            type: 'object',
            properties: {
                instanceTypes: {
                    type: 'array',
                    items: { type: 'string' },
                    minItems: 1,
                    maxItems: MAX_PRICED_TYPES,
                },
            },
            required: ['instanceTypes'],
            additionalProperties: false,
        },
        access: 'read',
    },
];
export const isInvestigationTool = (name) => INVESTIGATION_TOOLS.some((t) => t.name === name);
//# sourceMappingURL=tools.js.map